import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import util from "@/libs/util.js";
export default {
  data: function data() {
    return {
      searchForm: {},
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 表单
      form: {},
      dialogVisible: false,
      // 弹窗状态

      currentMenu: ""
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getMenuList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getMenuList: function getMenuList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, menuId;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getMenuList();
            case 1:
              res = _context2.v;
              menuId = _this2.$route.query.menuId;
              res.data.forEach(function (item) {
                if (item.children.length > 0) {
                  item.children.forEach(function (second) {
                    if (second.id == menuId) {
                      _this2.currentMenu = "".concat(item.menuName, " / ").concat(second.menuName);
                    }
                    if (second.children.length > 0) {
                      second.children.forEach(function (three) {
                        if (three.id == menuId) {
                          _this2.currentMenu = "".concat(item.menuName, " / ").concat(second.menuName, " / ").concat(three.menuName);
                        }
                      });
                    }
                  });
                }
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    deleteMenuButton: function deleteMenuButton(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this3.$confirm("\u786E\u8BA4\u5220\u9664\u5417?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return _this3.$api.deleteMenuButton({
                        menuId: _this3.$route.query.menuId,
                        buttonCode: row.buttonCode
                      });
                    case 1:
                      _this3.$message.success("操作成功");
                      _this3.getData();
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              })));
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getData: function getData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this4.tableLoading = true;
              _context5.n = 1;
              return _this4.$api.getMenuButtonList({
                menuId: _this4.$route.query.menuId
              });
            case 1:
              res = _context5.v;
              _this4.tableData = res.data;
              _this4.tableLoading = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this5.form.adminId = util.cookies.get("uuid");
              if (!_this5.form.buttonId) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return _this5.$api.updateMenuButton({
                menuId: _this5.$route.query.menuId,
                buttonCode: _this5.form.buttonCode,
                buttonName: _this5.form.buttonName
              });
            case 1:
              _context6.n = 3;
              break;
            case 2:
              _context6.n = 3;
              return _this5.$api.addMenuButton({
                menuId: _this5.$route.query.menuId,
                buttonCode: _this5.form.buttonCode,
                buttonName: _this5.form.buttonName
              });
            case 3:
              _this5.dialogVisible = false;
              _this5.form = {};
              _this5.getData();
            case 4:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    }
  }
};